module.exports = __webpack_public_path__ + "img/QRCode.52dbad00.png";